import { Injectable, signal } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ComprarService {
	// Signal que almacena la info
	compraInfo = signal<any>(null);

	setCompraInfo(data: any) {
		this.compraInfo.set(data);
	}
}
